'use strict';

angular.module('app.pages.dashboard')
  .factory('Reports', Reports);

function Reports($http, $q, esriLoader, appConfig) {

  let fields = [];

  let service = {
    query: query,
    generate: generate,
    brochure: brochure,
    dnrfutureletter: dnrfutureletter,
    unsold: unsold,
    classRec: classRec,
    revalue: revalue,
    forfeitValueChange: forfeitValueChange,
    preAuction: preAuction,
    postAuction: postAuction,
    dnrfutureauction: dnrfutureauction,
    classletter: classletter,
    cityDirectSaleLtr: cityDirectSaleLtr,
    adjacentletter: adjacentletter,
    convertImageToBase64: convertImageToBase64,
    formatAdjacentLetterData: formatAdjacentLetterData,
    processClassCities: processClassCities,
    processOwnerNotice: processOwnerNotice,
    finalSaleList: finalSaleList,
    exportUnmatchedList: exportUnmatchedList,
    exportBoardList: exportBoardList,
    _formatEsriDate: _formatEsriDate,
    _formatDate: _formatDate,
    getDomainValues: getDomainValues,
  };

  return service;

  // Load all reports in the system
  function query(params) {
    return $http.get('/api/v1/reports', {
        params: params
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  function generate(type, params) {
    console.log('report.generate');
    return $http.get('/api/v1/reports/' + type, {
        params: params
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  // generate a parcel brochure
  function brochure(tract, picture, map, background) {
    return $http.post('/api/v1/reports/brochure', {
        tract: tract,
        picture: picture,
        map: map,
        background: background
        // action: action || 'created'
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  // generate the dnr future direct sale letter
  function dnrfutureletter(tracts, background) {
    return $http.post('/api/v1/reports/dnrfutureletter', {
        tracts: tracts,
        background: background
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  // generate the unsold parcels list
  function unsold(params) {
    return $http.post('/api/v1/reports/unsold-parcels', {
        filetype: params.filetype,
        reportData: params.reportData
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }
  // TODO: CWCT-695
  // generate the classification recommendations reports
  function classRec(params) {
    return $http.post('/api/v1/reports/class-recs', {
        filetype: params.filetype,
        reportData: params.reportData,
        startDate: params.startDate,
        endDate: params.endDate,
        forfeitStatus: 'Acive'
      })
      .then(function(response) {
        console.log(params);
        console.log(response.data);
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  // generate the revaluation report
  function revalue(params) {
    return $http.post('/api/v1/reports/revalue', {
        filetype: params.filetype,
        reportData: params.reportData,
        date: params.date
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  // generate the revaluation report
  function forfeitValueChange(params) {
    console.log('reports.forfeitValueChange');
    return $http.post('/api/v1/reports/forfeit-value-change', {
        filetype: params.filetype,
        reportData: params.reportData,
        year: params.year
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error('forfeitValueChange', error);
      });
  }

  // generate the pre-auction report
  function preAuction(params) {
    return $http.post('/api/v1/reports/pre-auction', {
        filetype: params.filetype,
        reportData: params.reportData,
        date: params.date
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  // generate the pre-auction report
  function postAuction(params) {
    return $http.post('/api/v1/reports/post-auction', {
        filetype: params.filetype,
        reportData: params.reportData,
        date: params.date
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  // generate the dnr future public auction letter
  function dnrfutureauction(tracts, background) {
    return $http.post('/api/v1/reports/dnrfutureauctionltr', {
        tracts: tracts,
        background: background
      })
      .then(function(response) {
        console.log(response.data);
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  // generate the classification letter to city/township for future public auction
  function classletter(cities, background) {
    return $http.post('/api/v1/reports/cityclassletter', {
        cities: cities,
        background: background
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  // generate the attachment to the classification letter to city/township for future public auction
  function cityAuctionList(cities) {
    return $http.post('/api/v1/reports/cityAuctionList', {
        cities: cities
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  // generate the classification letter to city/township for future direct sale
  function cityDirectSaleLtr(cities, background) {
    return $http.post('/api/v1/reports/cityDirectSaleLtr', {
        cities: cities,
        background: background
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  function adjacentletter(parcels, background, count) {
    return $http.post('/api/v1/reports/adjacentletter', {
        parcels: parcels,
        background: background,
        count: count
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  function radiusletter(parcels, background, count) {
    return $http.post('/api/v1/reports/radiusletter', {
        parcels: parcels,
        background: background,
        count: count
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  function ownerletter(parcels, background) {
    console.log('parcels in factory', parcels);
    return $http.post('/api/v1/reports/ownerletter', {
        parcels: parcels,
        background: background
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  function finalSaleList(params) {
    return $http.post('/api/v1/reports/final-sale-list', params)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  // Converts an image in the file system to base64
  function convertImageToBase64(url) {
    let d = $q.defer(),
      img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = url;
    img.onload = function() {
      let canvas = document.createElement('CANVAS');
      let ctx = canvas.getContext('2d');
      let dataURL;
      canvas.height = this.height;
      canvas.width = this.width;
      ctx.drawImage(this, 0, 0);
      dataURL = canvas.toDataURL('image/png', 1.0);
      canvas = null;
      d.resolve(dataURL);
    };
    return d.promise;
  }

  function processClassCities(results, saletype) {
    let d = $q.defer();
    let letterFeatures = [];
    for (let id in results.features) {
      letterFeatures.push(results.features[id].attributes);
    }
    let cities = [];
    for (let i = 0; i < letterFeatures.length; i++) {
      // console.log(letterFeatures[i].Political_Sub);
      let city = _.find(cities, {
        'cityName': letterFeatures[i].Political_Sub
      });
      if (city == null) {
        let cityReport = {
          'cityName': letterFeatures[i].Political_Sub,
          'parcelCount': 1,
          'parcels': [letterFeatures[i]]
        };
        cities.push(cityReport);
      } else {
        city.parcels.push(letterFeatures[i]);
        city.parcelCount++;
      }
    }
    for (let i = 0; i < cities.length; i++) {
      //  console.log('CITIES[i]', cities[i]);
    }
    // console.log('LETTERFEATURES', letterFeatures);

    $http.get('/api/v1/reports/cityaddresses')
      .then(function(response) {
        let addresses = response.data;
        //  console.log('ADDRESSES', addresses);
        for (let i = 0; i < cities.length; i++) {
          cities[i].contact = _.find(addresses, function(address) {
            return address.cityName.toLowerCase() === cities[i].cityName.toLowerCase();
          });
          //    console.log(cities[i].contact);
        }

        let background = 'Crow_Wing_Letter_Head.png';
        if (saletype === 'Auction') {
          let mailing = {};
          classletter(cities, background)
            .then(function(letter) {
              mailing.letter = letter;
              cityAuctionList(cities)
                .then(function(list) {
                  mailing.list = list;
                  d.resolve(mailing);
                });
            });
        } else if (saletype === 'Direct Sale') {
          cityDirectSaleLtr(cities, background)
            .then(function(letter) {
              d.resolve(letter);
            });
        }
      });
    return d.promise;
  }

  function formatAdjacentLetterData(results, buffer, letterType) {
    let d = $q.defer();
    esriLoader.require([
      'esri/layers/FeatureLayer',
      'esri/tasks/query',
      'esri/geometry/geometryEngine',
      'esri/config',
      'esri/tasks/QueryTask'
    ], function(
      FeatureLayer,
      Query,
      geometryEngine,
      esriConfig,
      QueryTask
    ) {
      // try cors server here
      esriConfig.defaults.io.corsEnabledServers.push('gis.crowwing.us');

      let bufferFeatures = results.features;
      // console.log('bufferFeatures', bufferFeatures);
      let bufferGeometries = [];
      // console.log('buffer: ', buffer);
      for (let id in bufferFeatures) {
        let theBuffer = {
          geometry: '',
          attributes: ''
        };
        theBuffer.geometry = geometryEngine.buffer(bufferFeatures[id].geometry, buffer, 'feet');
        theBuffer.attributes = bufferFeatures[id].attributes;
        bufferGeometries.push(theBuffer);
      }
      // union the geometries into a single polygon
      //  let union = geometryEngine.union(bufferGeometries);
      // now select the adjacent parcels
      let queryParcels = new Query();
      queryParcels.spatialRelationship = Query.SPATIAL_REL_INTERSECTS;
      queryParcels.returnGeometry = false;
      queryParcels.outFields = ['*'];

      let parcelQueryTask = new QueryTask(appConfig.getConfig().parcelService);
      _selectParcels(bufferGeometries, queryParcels, parcelQueryTask, letterType).then(function(parcels) {
      //   console.log('parcels', parcels);
        let reportFeatures = {};
        for (let id in parcels) {
          // console.log('parcel:', parcels[id]);
          reportFeatures[id] = {
            owners: '',
            address: ''
          };
          // remove tax forfeit and null values from the letters being generated
          let reportAttributes = [];
          let addr1s = [];
          // loop through each adjacent parcel
          for (let i = 0; i < parcels[id].features.length; i++) {
            if (parcels[id].features[i].attributes.OWNAME == null || parcels[id].features[i].attributes.OWNAME.indexOf('FORFEITED') > -1) {
              console.log('REMOVE ', parcels[id].features[i].attributes.OWNAME);
            } else if (addr1s.indexOf(parcels[id].features[i].attributes.OWADR1) < 0) {
              addr1s.push(parcels[id].features[i].attributes.OWADR1);
              reportAttributes.push(parcels[id].features[i]);
            }
          }
          reportFeatures[id].owners = reportAttributes;
          console.log('REPORTFEATURES[ID].OWNERS', reportFeatures[id].owners);
          let address = _getAddress(bufferGeometries, id, letterType);
          reportFeatures[id].address = address;
          for (let i = 0; i < bufferGeometries.length; i++) {
            if (id === bufferGeometries[i].attributes.Tract) {
              reportFeatures[id].auctionDate = bufferGeometries[i].attributes.Last_LS_date;
            }
          }
        }
        console.log('reportFeatures', reportFeatures);
        let background = 'Crow_Wing_Letter_Head.png';
        if (letterType === 'adjacent') {
          adjacentletter(reportFeatures, background, bufferFeatures.length).then(function(letter) {
            d.resolve(letter);
          });
        } else if (letterType === 'radius120ft') {
          radiusletter(reportFeatures, background, bufferFeatures.length).then(function(letter) {
            d.resolve(letter);
          });
        }
      });
    });
    return d.promise;
  }

  function processOwnerNotice(results) {
    console.log('processOwnerNotice');
    let d = $q.defer();
    // esriLoader.require([
    //   'esri/tasks/query',
    //   'esri/tasks/QueryTask',
    //   'esri/request'
    // ], function(
    //   Query,
    //   QueryTask,
    //   esriRequest
    // ) {
      let parcels = results.features;
      // let pinNums = [];
      // for (let id in parcels) {
      //   pinNums.push('\'' + parcels[id].attributes.PIN + '\'');
      //   //   console.log(parcels[id].attributes);
      // }
      // let queryTaxParcels = new Query();
      // queryTaxParcels.returnGeometry = false;
      // let where = 'APPRCL IN (' + pinNums.join(',') + ')';
      // let requestHandle = esriRequest({
      //   'url': 'https://gis.crowwing.us/cwcexternal/rest/services/CROWWINGPUBLIC/MapServer/0/query',
      //   'content': {
      //     'f': 'json',
      //     'where': where,
      //     'returnGeometry': false,
      //     'outFields': '*'
      //   },
      //   'handeAs': 'json',
      //   'usePost': true,
      //   'callbackParamName': 'callback'
      // }, {
      //   usePost: true
      // });
      // requestHandle.then(function(results) {
      //   let taxparcels = results.features;
        //  console.log('results', taxparcels);

        for (let i = 0; i < parcels.length; i++) {
          parcels[i] = parcels[i].attributes;
          if (parcels[i].Forfeiture_date.date === undefined) {  // if letter is being generated from Step 1
            parcels[i].Forfeiture_date = _formatEsriDate(parcels[i].Forfeiture_date);
          } else {  // if letter is generated from Parcel Details page
            parcels[i].Forfeiture_date = parcels[i].Forfeiture_date.date;
          }
          // console.log('Forfeiture date: ', parcels[i].Forfeiture_date);
          // for (let j = 0; j < taxparcels.length; j++) {
          //   if (parcels[i].PIN === taxparcels[j].attributes.APPRCL) {
          //     parcels[i].taxOwner = taxparcels[j].attributes.TXNAME;
          //     parcels[i].addr1 = taxparcels[j].attributes.TXADR1;
          //     parcels[i].addr2 = taxparcels[j].attributes.TXADR2;
          //     parcels[i].addr3 = taxparcels[j].attributes.TXADR3;
          //     parcels[i].addr4 = taxparcels[j].attributes.TXADR4;
          //   }
          // }
        }
        let background = 'Crow_Wing_Letter_Head.png';
        ownerletter(parcels, background)
          .then(function(letter) {
            d.resolve(letter);
          });
      // }, function(results) {
      //   d.resolve('error');
      //   console.log('error', results);
      // });
    // });
    return d.promise;
  }

  function exportUnmatchedList(unmatchedList) {
    return $http.post('/api/v1/reports/unmatchedlist', {
        list: unmatchedList
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  function exportBoardList(boardList) {
    console.log('boardlist', boardList);
    let exportFeatures = _formatAllDates(angular.copy(boardList));
    console.log(exportFeatures);
    return $http.post('/api/v1/reports/boardtractlist', {
        list: exportFeatures
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error(error);
      });
  }

  // Concatenate the address for a given Tract or parcel
  function _getAddress(allTracts, parcelOrTractid, letterType) {
    for (let i = 0; i < allTracts.length; i++) {
      let identifier;
      if (letterType === 'radius120ft') {
        identifier = allTracts[i].attributes.Tract;
      } else if (letterType === 'adjacent') {
        identifier = allTracts[i].attributes.OBJECTID.toString();
        // console.log('identifier', identifier);
      }
      if (identifier === parcelOrTractid) {
        if (letterType === 'radius120ft') {
          return allTracts[i].attributes.PhysAddr + ' ' + allTracts[i].attributes.PhysCity + ' ' + allTracts[i].attributes.PhysZip;
        } else if (letterType === 'adjacent') {
          if (allTracts[i].attributes.PlatDesc != null && allTracts[i].attributes.PlatDesc !== ' ') {
            return allTracts[i].attributes.Legals + ', ' + allTracts[i].attributes.PlatDesc;
          } else {
            return allTracts[i].attributes.Legals + ', Section ' + allTracts[i].attributes.Sec + ', Township ' + allTracts[i].attributes.Twp + ', Range ' + allTracts[i].attributes.Rnge;
          }
        }
      }
    }
  }

  function _selectParcels(geometries, query, queryTask, letterType) {
    // TODO: consider making this a single query instead of multiple
    let promises = {};
    for (let i = 0; i < geometries.length; i++) {
      query.geometry = geometries[i].geometry;
      if (letterType === 'radius120ft') {
        promises[geometries[i].attributes.Tract] = queryTask.execute(query);
      } else if (letterType === 'adjacent') {
        promises[geometries[i].attributes.OBJECTID] = queryTask.execute(query);
      }
    }
    return $q.all(promises);
  }

  function _formatEsriDate(date) {
    let newDate = new Date(date);
    date = new Date(newDate.getTime() + newDate.getTimezoneOffset() * 60000);
    return date;
  }

  function _formatAllDates(features) {
    let formattedList = [];
    for (let i = 0; i < features.length; i++) {
      for (let attribute in features[i].attributes) {
        if (typeof features[i].attributes[attribute] === 'object') {
          if (features[i].attributes[attribute] != null) {
            if (features[i].attributes[attribute].hasOwnProperty('date')) {
              // console.log('date field ', attribute);
              if (features[i].attributes[attribute].date != null) {
                features[i].attributes[attribute] = _formatDate(features[i].attributes[attribute].date);
              } else {
                features[i].attributes[attribute] = null;
              }
            }
          }
        } else if (attribute === 'GlobalID' || attribute === 'OBJECTID') {
          delete features[i].attributes[attribute];
          // Hackish? but gets the job done
        } else if (attribute.indexOf('date') > -1 || attribute.indexOf('Date') > -1){
          if (features[i].attributes[attribute] != null) {
            features[i].attributes[attribute] = _formatDate(_formatEsriDate(features[i].attributes[attribute]));
          } else {
            features[i].attributes[attribute] = null;
          }
        }
      }
      // finally add just the attributes object to an array
      formattedList.push(features[i].attributes);
    }
    return formattedList;
  }

  function getDomainValues(field) {
    return _.find(fields, {
      'name': field
    }).domain.codedValues;
  }
  // jshint ignore:start
  function _formatDate(date) {
    return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
  }
  // jshint ignore:end
}
